import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { inWords2, calcChallanNetRate } from '../../utils';
import _ from 'lodash';
import { baseUrl } from '../../config/api';

export const challan3Template = (data) => {
  return new Promise((resolve) => {
    const {
      qr,
      qrCode,
      clientAddress,
      clientName,
      challanDate,
      items,
      challanCode,
      entityName,
      entityId,
      packagingCost,
      createdAt,
      hideRate = false,
      ad = ""
    } = data;
    console.log('runningChallanBalance22', data?.runningChallanBalance);
    console.log(qr, qrCode, "qrc")

    const code = entityId === '62da46cf7eb6aa02db41297f' ? 'VO' :
      entityId === '62da46c57eb6aa02db41297d' ? 'IE' : `Astra Lenses Eyecare`;

    let totalQuantity = 0;
    let totalAmount = 0;

    const rows = items.map((item, index) => {
      totalQuantity += Number(item.quantity);
      totalAmount += Number(item.amount);
      if (hideRate) {
        return [
          index + 1,
          `${item.nameR ? `R/${item?.nameR} [${item.rProductCode?.substring(3)}]` : ''}\n${item.nameL ? `L/${item?.nameL} [${item.lProductCode?.substring(3)}]` : ''}${item.orderRef ? `\nOrd Ref: ${item.orderRef}` : ''}`,
          item.quantity,
        ];
      }
      let discountDisplay = '';
      if (item.discountPercent && Number(item.discountPercent) > 0) {
        discountDisplay = `${item.discountPercent}%`;
      } else if (item.discountAmount && Number(item.discountAmount) > 0) {
        discountDisplay = String(_.round(item.discountAmount, 2));
      }
      const { fitting, fittingAmount, tint, arc } = item;
      return [
        index + 1,
        `${item.nameR ? `R/${item?.nameR} [${item.rProductCode?.substring(3)}]` : ''}\n${item.nameL ? `L/${item?.nameL} [${item.lProductCode?.substring(3)}]` : ''}${item.orderRef ? `\nOrd Ref: ${item.orderRef}` : ''}`,
        item.quantity,
        `${item?.rateR || ''}\n${item?.rateL || ''}`,
        discountDisplay,
        calcChallanNetRate(item),
        `${fitting ? `Fitt:${fitting}-${fittingAmount}` : ''}\n${tint ? `tint:${tint}` : ''}\n${arc ? `ARC:${arc}` : ''}`,
        _.round(item.amount, 2).toFixed(2),
      ];
    });

    const totalAmountWithPackaging = totalAmount + Number(packagingCost);
    const totalAmountInWords = inWords2(totalAmountWithPackaging);

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a6',
    });

    const headers = hideRate
      ? [['#', 'Name', 'Qty']]
      : [['#', 'Name', 'Qty', 'Rate', 'Disc', 'Net Rate', 'Extra Charges', 'Amt']];

    doc.setFontSize(5.6);

    // Calculate startY based on whether address is displayed
    const addressHeight = (clientAddress && clientAddress.trim() !== '') 
      ? (doc.splitTextToSize(clientAddress, 90).length * 3) + 2 
      : 0;
    const tableStartY = 22 + addressHeight;
    
    // A6 usable width ≈ 100mm (105 − margins). Name was ~20mm auto → +40% = 28mm.
    const columnStyles = hideRate
      ? { 0: { cellWidth: 8 }, 1: { cellWidth: 28 } }
      : {
          0: { cellWidth: 7 },
          1: { cellWidth: 28 },
          2: { cellWidth: 7 },
          3: { cellWidth: 11 },
          4: { cellWidth: 9 },
          5: { cellWidth: 11 },
          6: { cellWidth: 12 },
          7: { cellWidth: 15, halign: 'right' },
        };

    doc.autoTable({
      margin: { left: 2, right: 3, top: 2 },
      head: headers,
      body: rows,
      columnStyles,
      startY: tableStartY, // Adjusted to accommodate party name and address
      styles: {
        fontSize: 5.6,
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fontStyle: 'bold',
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        valign: 'middle',
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
        fontSize: 5.6,
      },
      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 0.1,
        lineColor: [0, 0, 0],
      },
      tableLineWidth: 0.1,
      tableLineColor: [0, 0, 0],
      didDrawPage: function (data) {
        if (data.pageCount === 1) {
          doc.setFontSize(9);
          doc.text('Approval Memo', 5, 10);
          doc.text(code, 52.5, 10, { align: 'center' });
          doc.text(`Dt: ${createdAt}`, 100, 10, { align: 'right' });
          
          // Party name with larger font size and on separate line
          doc.setFontSize(10);
          doc.setFont(undefined, 'bold');
          doc.text(`M/S: ${clientName}`, 5, 15);
          
          // Address below party name (if available) - make it bold
          let addressY = 20;
          if (clientAddress && clientAddress.trim() !== '') {
            doc.setFontSize(7);
            doc.setFont(undefined, 'bold');
            const addressLines = doc.splitTextToSize(clientAddress, 90);
            addressLines.forEach((line) => {
              doc.text(line, 5, addressY, { fontStyle: 'bold' });
              addressY += 3;
            });
          }
          
          // Challan code on separate line to prevent merging
          doc.setFontSize(8);
          doc.setFont(undefined, 'normal');
          doc.text(`${challanCode.split('-')[0]}/${challanCode.split('-')[3]}`, 100, 15, { align: 'right' });
        }
        doc.text(`Page ${data.pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 2);
      },
    });

    const mainTable = doc.lastAutoTable;
    const finalY = mainTable.finalY;

    const cols = mainTable?.columns || [];
    const tableMarginLeft = 2;
    const colStart = (index) =>
      tableMarginLeft + cols.slice(0, index).reduce((sum, col) => sum + (col.width || 0), 0);
    const colEnd = (index) => colStart(index) + (cols[index]?.width || 0);
    const amountColIndex = hideRate ? 2 : 7;
    const qtyColIndex = 2;

    let footerY = finalY + 4;
    const footerLineHeight = 5;
    doc.setFont(undefined, 'bold');
    doc.setFontSize(7);

    const drawFooterLine = (label, qtyText, amountText) => {
      doc.text(label, colStart(0) + 1, footerY);
      if (qtyText) {
        doc.text(qtyText, colStart(qtyColIndex) + 1, footerY);
      }
      if (amountText != null && amountText !== '') {
        doc.text(String(amountText), colEnd(amountColIndex) - 1, footerY, { align: 'right' });
      }
      footerY += footerLineHeight;
    };

    if (hideRate) {
      drawFooterLine(`Total Qty: ${totalQuantity}`, null, null);
      if (data?.runningChallanBalance !== null && data?.runningChallanBalance !== undefined) {
        drawFooterLine('Balance Up To Date:(RCB)', null, `${_.round(data.runningChallanBalance, 2).toFixed(2)}`);
      }
    } else {
      drawFooterLine('Sub Total', `Qty:${totalQuantity}`, _.round(totalAmount, 2).toFixed(2));
      drawFooterLine('Packaging Cost', null, _.round(Number(packagingCost), 2).toFixed(2));
      drawFooterLine('Total Amount', null, _.round(totalAmount + Number(packagingCost), 2).toFixed(2));
      if (data?.runningChallanBalance !== null && data?.runningChallanBalance !== undefined) {
        drawFooterLine('Balance Up To Date:(RCB)', null, `${_.round(data.runningChallanBalance, 2).toFixed(2)}`);
      }
    }

    const pageWidth =
      (typeof doc.internal.pageSize.getWidth === 'function' && doc.internal.pageSize.getWidth()) ||
      doc.internal.pageSize.width;
    const footerTextWidth =
      mainTable && typeof mainTable.getWidth === 'function'
        ? mainTable.getWidth(pageWidth)
        : pageWidth - 8;

    let noteY = footerY + 3;
    doc.setFontSize(7);
    doc.setFont(undefined, 'normal');
    if (!hideRate) {
      const inWordsLines = doc.splitTextToSize(
        `Total Amount in words: ${totalAmountInWords} Rupees Only`,
        footerTextWidth - 6
      );
      inWordsLines.forEach((line) => {
        doc.text(line, 5, noteY);
        noteY += 4;
      });
      noteY += 2;
    }
    doc.text('E & OE', 5, noteY);
    noteY += 4;
    doc.text('Working Hours: 10.30 AM to 7.00 PM', 5, noteY);
    noteY += 4;
    
    // Display print ads at the bottom (if available)
    if (ad && ad.trim() !== '') {
      const pageWidth = doc.internal.pageSize.getWidth();
      const leftMargin = 5;
      const rightMargin = 5;
      const maxTextWidth = pageWidth - leftMargin - rightMargin;
      const adText = ad.trim();
      const splitAdText = doc.splitTextToSize(adText, maxTextWidth);
      
      let adY = noteY + 4;
      splitAdText.forEach((line) => {
        doc.text(line, leftMargin, adY, { halign: 'left', fontStyle: 'normal' });
        adY += 3;
      });
    }

    const getBlobAndResolve = () => {
      const pdfBlob = doc.output('blob');
      resolve(pdfBlob);
    };

    if (qr && qrCode && qrCode.trim() !== '') {
      const qrCodeUrl = `${baseUrl}${qrCode}`;
      console.log('Loading QR code from:', qrCodeUrl);
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = qrCodeUrl;

      img.onload = function () {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const qrBase64 = canvas.toDataURL('image/png');

          // Get total number of pages and set to last page
          const totalPages = doc.internal.getNumberOfPages();
          doc.setPage(totalPages);

          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const qrSize = 30;
          const margin = 5;
          const x = pageWidth - qrSize - margin;
          const y = pageHeight - qrSize - margin;

          doc.addImage(qrBase64, 'PNG', x, y, qrSize, qrSize);
          console.log(`QR code added to PDF on page ${totalPages} at position:`, x, y);
          getBlobAndResolve();
        } catch (error) {
          console.error("Error adding QR code to PDF:", error);
          getBlobAndResolve();
        }
      };

      img.onerror = function (error) {
        console.error("QR Code image couldn't be loaded from:", qrCodeUrl, error);
        getBlobAndResolve();
      };
    } else {
      console.log('QR code not included - qr:', qr, 'qrCode:', qrCode);
      getBlobAndResolve();
    }
  });
};
